import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useDispatch } from 'react-redux';
import { searchFacetChange } from '../Actions/FacetedSearch.action';
import { translate } from '../Services/translation';
import { Svg } from "./Svg";
const FilterTags = ({ facetFilters, navigationTheme }) => {
    const dispatch = useDispatch();
    const selectedFacetGroup = facetFilters.filter((filter) => filter.selectedOptions.length > 0);
    const selectedFacetOption = selectedFacetGroup.reduce((accumulator, group) => {
        if (!group) {
            return accumulator;
        }
        const { options, selectedOptions } = group;
        const groupOptions = options
            .filter((option) => selectedOptions.includes(option.id))
            .map((option) => ({ ...option, group }));
        return [...accumulator, ...groupOptions];
    }, []);
    return selectedFacetGroup.length === 0 ? null : (_jsxs("div", { className: "selected-filter hide-for-large", children: [_jsxs("span", { children: [_jsxs("span", { children: [" ", translate('search.yourfilter'), " : "] }), selectedFacetGroup &&
                        selectedFacetGroup.map((group, index) => (_jsxs("span", { className: "selected-filter__tag", onClick: (event) => dispatch(searchFacetChange(group)), children: [' ', group.label, _jsx(Svg, { icon: "close" })] }, `group-${index}`)))] }), navigationTheme === 'category' && (_jsxs("span", { className: "show-for-large", children: [_jsxs("span", { children: [" ", translate('search.yourfilter'), " : "] }), selectedFacetOption &&
                        selectedFacetOption.map((option, index) => (_jsxs("span", { className: "selected-filter__tag", onClick: (event) => dispatch(searchFacetChange(option.group, option)), children: [' ', option.label, ' '] }, `option-${index}`)))] }))] }));
};
export default FilterTags;
